import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ResourceManagerService } from '@barthauer/abc/core/resources';
import { BasysMapFrameService } from '@barthauer/basys/map-frame';
import { ResourceEventEditBase } from '../resource-event-edit-base/resource-event-edit-base.component';
import { ResourcesService } from '../resources.service';

@Component({
    selector: 'app-resource-event-vehicle-operating-hours',
    templateUrl: './resource-event-vehicle-operating-hours.component.html',
    styleUrls: ['./resource-event-vehicle-operating-hours.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class ResourceEventVehicleOperatingHoursComponent extends ResourceEventEditBase implements OnInit, OnDestroy {
  constructor(
    resourceManagerService: ResourceManagerService,
    resourcesService: ResourcesService,
    frame: BasysMapFrameService
  ) {
    super();
    super.init(frame, resourcesService, resourceManagerService);
  }

  async ngOnInit() {
    super.ngOnInit();
  }
  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
